<template>
  <div class="flex-display js-between ai-center width-100">
    <p>{{number + name}}</p>
    <el-rate
        v-model="rate"
        class="text-left"
        void-color="#FFB800"
        @change="setRate(id, rate)"
        :disabled="disabled"
      ></el-rate>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    data: {
      type: Object,
      default() {
        return null;
      },
    },
    id: {
      type: String,
      default() {
        return "";
      },
    },
    number: {
      type: String,
      default() {
        return "";
      },
    },
    name: {
      type: String,
      default() {
        return "";
      },
    },
    rateDefault: {
      type: Number,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      rate: 0,
    };
  },
  mounted() {
    this.setRateDefault();
  },
  watch: {
    rateDefault() {
      this.setRateDefault();
    },
  },
  methods: {
    setRateDefault() {
      this.rate = this.rateDefault;
    },
    setRate(key, rate) {
      this.$emit("setRate", key, rate);
    },
  },
};
</script>